import { render, staticRenderFns } from "./DataFeedBackList.vue?vue&type=template&id=04ca15b0"
import script from "./DataFeedBackList.vue?vue&type=script&lang=js"
export * from "./DataFeedBackList.vue?vue&type=script&lang=js"
import style0 from "./DataFeedBackList.vue?vue&type=style&index=0&id=04ca15b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports